import React, { useState } from 'react';
import  '../sections/Education.css';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import * as data from '../../Lokesh_Profile.json'
const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}
const contact = data.about
// const contact = [{
//     "location":'Chennai, India',
//     "phone":"+91-9566132637",
//     "email":"lokeshkumar824@gmail.com",
//     "github":"https://github.com/Lokesh824",
//     "linkedin":"https://www.linkedin.com/in/lokesh824/",
//     "medium":"https://medium.com/@lokeshkumar824"
// }]
const Profile = [{
  headline:"I'm a Software Engineer & Fullstack Web Developer from India. I aim to make a difference through my skills and experience."
}]
const Contact = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  }

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  }   

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );



  return (
    <section class="ftco-section contact-section" style={{marginTop:'20vh'}}>
    <div class="container mt-5  reveal-from-bottom"  data-reveal-delay="200">
      <div class="row d-flex mb-5 contact-info">
        <div class="col-md-12 mb-4">
          <h2 class="h4">Contact Information</h2>
        </div>
        <div class="w-100"></div>
        <div class="col-md-4">
          <p><span>Location:</span> {contact[0].location}</p>
        </div>
        <div class="col-md-4">
          <p><span>Phone:</span> <a href="#">{contact[0].phone}</a></p>
        </div>
        <div class="col-md-4">
          <p><span>Email:</span> <a href={contact[0].email}>{contact[0].email}</a></p>
        </div>
       
      </div>
      <h2 class="h4">Reach out</h2>
      <br />
      <div class="row block-9">
        <div class="col-md-12 pr-md-12">
          <form action="https://formspree.io/f/mgepnraw" method="POST">
            <div class="form-group">
              <input type="text" class="form-control" placeholder="Your Name" name="name" />
            </div>
            <div class="form-group">
              <input type="email" class="form-control" placeholder="Your Email" name="email" />
            </div>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="Subject" name="subject" />
            </div>
            <div class="form-group">
              <textarea name="text" id="" cols="30" rows="7" class="form-control" placeholder="Message"></textarea>
            </div>
            <div class="form-group">
              <input type="submit" value="Send Message" class="btn btn-primary py-3 px-5" />
            </div>
          </form>
        </div>
        </div>
</div>
</section>
  );
}

export default Contact;